import React, {useState} from 'react';
import {Form, FormControl, FormLabel, Row} from "react-bootstrap";
import {useForm} from "react-hook-form";

const PhoneNumber: React.FC<any> = ({ onSuccess, phone_number }) => {

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = (data: any) => {
        onSuccess(data.phone_number);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
                <FormLabel htmlFor="phone_number">
                    <i className="fa fa-phone" /> شماره تماس *
                </FormLabel>
                <FormControl className="ltr" defaultValue={phone_number} id="phone_number" {...register('phone_number', {
                    required: {
                        message: "ورود شماره تماس الزامیست!",
                        value: true
                    }
                })} />
                {errors.phone_number && <p className="text-danger">{errors.phone_number.message as string}</p>}
            </div>
            <div className={'mt-5'}>
                <input type="submit" value="ارسال کد" className="btn w-100 btn-primary" />
            </div>
        </Form>
    );
}

export default PhoneNumber;
